import { css, cx } from 'linaria';
import { Modal, ModalBody } from 'components/modal/modal';
import { useTranslation } from 'next-i18next';
import { PremiumIcon } from 'components/icons/PremiumIcon';
const shortcutsStyle = "si9hqdm";
export function ShortCutDisplay({
  copy,
  keyCopy,
  premium,
  isPremium
}) {
  const rowClass = cx(premium && !isPremium && 'locked');
  return <tr key={keyCopy} className={rowClass}>
      <td>{copy}</td>
      <td>
        {premium ? <PremiumIcon className="premium-icon" /> : null} {keyCopy}
      </td>
    </tr>;
}
export function ShortCutsView({
  showModal,
  isPremium,
  listShortcuts,
  itemActions,
  readerShortcuts,
  appRootSelector,
  cancelShortcutView
}) {
  const {
    t
  } = useTranslation();
  return <Modal title={t('shortcuts:shortcut-header', 'Keyboard Shortcuts')} appRootSelector={appRootSelector} isOpen={showModal} screenReaderLabel={t('shortcuts:shortcut-header', 'Keyboard Shortcuts')} handleClose={cancelShortcutView}>
      <ModalBody>
        <div className={shortcutsStyle}>
          <table>
            <thead>
              <tr>
                <th scope="col">List Actions</th>
                <th scope="col">Shortcut</th>
              </tr>
            </thead>
            <tbody>
              {listShortcuts.map(({
              copy,
              keyCopy,
              premium
            }) => <ShortCutDisplay copy={copy} key={keyCopy} keyCopy={keyCopy} premium={premium} isPremium={isPremium} />)}
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th scope="col">Item Actions</th>
                <th scope="col">Shortcut</th>
              </tr>
            </thead>
            <tbody>
              {itemActions.map(({
              copy,
              keyCopy,
              premium
            }) => <ShortCutDisplay copy={copy} key={keyCopy} keyCopy={keyCopy} premium={premium} isPremium={isPremium} />)}
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th scope="col">Reading Actions</th>
                <th scope="col">Shortcut</th>
              </tr>
            </thead>
            <tbody>
              {readerShortcuts.map(({
              copy,
              keyCopy,
              premium
            }) => <ShortCutDisplay copy={copy} key={keyCopy} keyCopy={keyCopy} premium={premium} isPremium={isPremium} />)}
            </tbody>
          </table>
        </div>
      </ModalBody>
    </Modal>;
}

require("./shortcuts-view.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./shortcuts-view.js");